/*
 * @Author: heyu tao
 * @since: 2021-11-17 09:45:31
 * @LastAuthor: CDS
 * @lastTime: 2022-07-21 09:18:50
 * @message: file content
 * @The path of the file relative to the project: /cds-portal-web/src/main.js
 */
import 'babel-polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from "vue";
import App from "./App.vue";

Vue.config.productionTip = false;

import "./style/index.less"

// 导入路由
import VueRouter from "vue-router"
Vue.use(VueRouter)
// 重写路由push方法，捕捉路径重复时的错误
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
import router from "./router/index"

// 导入API
import $api from "@/api/index.js"
Vue.use($api);

// 按需导入组件
import  Element,{Image, Button, Input, Pagination, Link,Dialog } from 'element-ui';
//import 'scss/element-variables.scss' // element-theme-css
Vue.use(Dialog)
Vue.use(Button)
Vue.use(Input)
// Vue.use(Breadcrumb);Breadcrumb, BreadcrumbItem
// Vue.use(BreadcrumbItem)
Vue.use(Pagination);
Vue.use(Link)
Vue.use(Image)
// 注册全局组件：none
import NoneIcon from "./components/None.vue";
Vue.component('none-icon', NoneIcon)
import VClamp from "./components/VueClamp.vue"
// import VClamp from "./components/Clamp.js"
Vue.component('v-clamp', VClamp)

// 注册全局指令：文本搜索字体变红
Vue.directive('reds', {
  inserted: function (el, opts) {
    // console.log("dom挂在时：", opts)
    if (opts.value) {
      let reg = new RegExp(opts.value, 'g')
      // el.innerText
      el.innerHTML = el.innerText.replace(reg, '<span style="color:red">' + opts.value + '</span>')
    }

  },
  update: function (el, opts) {
    // console.log("dom更新时：", opts)
    if (opts.value) {
      let reg = new RegExp(opts.value, 'g')
      el.innerHTML = el.innerText.replace(reg, '<span style="color:red">' + opts.value + '</span>')
    }
  }
})

// 挂载个事件总线吧，给页脚传点数据，不想使store了
Vue.prototype.$eventBus = new Vue()
// set-footer : 给页尾设置数据


new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");